export const abilities = [
  "Acid blood",
  "Acid Spray",
  "Carapace",
  "Cleave/Spread Shot",
  "Crawler",
  "Dazzle",
  "Drain",
  "Entangle",
  "Explosive",
  "Flame Attack",
  "Immune",
  "Infectous",
  "Metallic Claws",
  "Paralyzing Bite/Shot",
  "Putrid",
  "Rebirth",
  "Regenerate",
  "Tough",
  "Uncanny Speed",
  "Vicious",
];

export const psychicAbilities = [
  "Buffer",
  "Control",
  "Distressing",
  "Dread",
  "Inspire Terror",
  "Mind Lash",
  "Organize",
  "Stun",
  "Suffocate",
  "Telekinetic Push",
];
